import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { FileUploadConfig } from '@shared/models';
import { FileService } from '@shared/services/files';
import { FileUploadType, StaticMessage } from '@shared/enums';

import { DprAttachmentsGridData } from '@shared/models/grid';
import { DprAttachmentService } from '@shared/services/dpr';

@Component({
  selector: 'app-attachments-upload',
  templateUrl: './attachments-upload.component.html',
  styleUrls: ['./attachments-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsUploadComponent {
  //#region Inputs

  @Input({ required: true }) fileUploadConfig: FileUploadConfig;
  @Input({ required: true }) clientId: string;
  @Input() shouldDisplayCounter = true;

  //#endregion

  //#region Outputs

  @Output() filesUploaded = new EventEmitter<DprAttachmentsGridData[]>();

  @Output() files = new EventEmitter<File[]>();

  //#endregion

  StaticMessage = StaticMessage;

  constructor(
    private fileService: FileService,
    private dprAttachmentService: DprAttachmentService
  ) {}

  async onFilesChanged(files: File[]): Promise<void> {
    if (!files?.length) {
      return;
    }

    if (this.fileUploadConfig.isNoServerUpload) {
      this.files.emit(files);
      return;
    }

    const attachments = [];

    // https://www.coreycleary.me/why-does-async-await-in-a-foreach-not-actually-await
    for (const file of files) {
      const uploadedFile = await firstValueFrom(
        this.fileService.uploadFile(
          file,
          FileUploadType.Attachment,
          this.clientId,
          false
        )
      );

      const attachment =
        this.dprAttachmentService.mapFileToDprAttachmentGridData(
          uploadedFile.file,
          uploadedFile.url
        );

      attachments.push(attachment);
    }

    this.filesUploaded.emit(attachments);
  }
}
